import React from "react";
import DashboardView from "./DashboardView";

// No se reutiliza el Inicio de facturacion: el inicio del modulo es el Dashboard.
const HomeView = () => <DashboardView />;

export default HomeView;
